import { render, staticRenderFns } from "./textareaCom.vue?vue&type=template&id=19c69d1a"
import script from "./textareaCom.vue?vue&type=script&lang=js"
export * from "./textareaCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports